import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-statement",
    templateUrl: "./statement.component.html"
})
export class FUIStatementComponent {
    @Input() title: string;
    @Input() value: string;

    constructor() {

    }
}
